import React from 'react';
import classnames from 'classnames';
import invariant from 'utils/invariant';
import { Icon } from 'ui';

const Item = ({
  buttonClassName,
  iconClassName,
  disabled = false,
  onClick,
  url,
  openInNewTab = false,
  icon,
  FeatherIcon = false,
  content,
  secondaryAction,
  secondaryText,
}) => {
  invariant(
    !(onClick && openInNewTab),
    'ActionList actions with an onClick handler cannot use the openInNewTab option.',
  );
  invariant(
    !(onClick && url),
    "ActionList actions can't have both a url and onClick set.",
  );
  invariant(
    !(icon && FeatherIcon),
    "ActionList actions can't have both an icon and a featherIcon set.",
  );
  return (
    <li className="ActionList-item">
      {url && (
        <a
          href={url}
          className="ActionList-itemButton"
          {...(openInNewTab && { target: '_blank' })}
        >
          {icon && (
            <Icon
              className={classnames('ActionList-itemButtonIcon', {
                [iconClassName]: !!iconClassName,
              })}
              name={icon}
            />
          )}
          {FeatherIcon && (
            <FeatherIcon
              className={classnames('ActionList-itemButtonFeatherIcon', {
                [iconClassName]: !!iconClassName,
              })}
            />
          )}
          {content}
        </a>
      )}
      {onClick && (
        <button
          type="button"
          onClick={onClick}
          disabled={disabled}
          className={classnames('ActionList-itemButton', {
            [buttonClassName]: !!buttonClassName,
            'ActionList-itemButton--withSecondary': secondaryText,
          })}
        >
          {icon && (
            <Icon
              className={classnames('ActionList-itemButtonIcon', {
                [iconClassName]: !!iconClassName,
              })}
              name={icon}
            />
          )}
          {FeatherIcon && (
            <FeatherIcon
              className={classnames('ActionList-itemButtonFeatherIcon', {
                [iconClassName]: !!iconClassName,
              })}
            />
          )}
          {content}
        </button>
      )}
      {secondaryText && (
        <button
          type="button"
          className="ActionList-secondaryAction u-linkBtn"
          onClick={secondaryAction}
        >
          {secondaryText}
        </button>
      )}
    </li>
  );
};

export default Item;
